import React from 'react';
import { useSelector } from 'react-redux';
import '../../stylings/Loader.css';

export default function Loader() {
  const loading = useSelector((state) => state.loader.loading);
  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-spinner">
        <div className="spinner-ring"></div>
        <img src="/logo.png" alt="Akash Model School" className="loader-logo" />
      </div>
    </div>
  );
}
